import { useContext } from 'react';

import { ThemeContext } from 'styled-components';

import { Theme } from 'themes/contracts';

export function useTheme(): Theme {
  return useContext(ThemeContext);
}
